import type { BoxProps } from '@chakra-ui/react';
import { HStack, Text } from '@chakra-ui/react';
import { AdvancedImage } from '@cloudinary/react';
import { format } from '@cloudinary/url-gen/actions/delivery';
import { scale } from '@cloudinary/url-gen/actions/resize';
import { auto } from '@cloudinary/url-gen/qualifiers/format';
import { cloudinary } from 'lib/cloudinary';

export const CUSTOMER_COUNT = '200,000+';

export const CUSTOMERS_STACK_IMAGE = cloudinary
  .image('constants/customers-stack')
  .resize(scale().width(112).height(48))
  .delivery(format(auto()));

export const CustomerResults = (props: BoxProps) => (
  <HStack
    display="inline-flex"
    spacing="4xs"
    bg="gray.50"
    border="1px solid"
    borderColor="blackAlpha.250"
    borderRadius="full"
    pl="5xs"
    pr="2xs"
    py="5xs"
    width="fit-content"
    {...props}
  >
    {/* NOTE: Native lazy loading instead of the lazyload() plugin - the
        plugin renders the img without src until an IntersectionObserver
        fires, which races Chromatic snapshots into a broken image. */}
    <AdvancedImage
      cldImg={CUSTOMERS_STACK_IMAGE}
      alt="Abstract customer icons"
      width={56}
      height={24}
      loading="lazy"
    />
    <Text size="detail" fontWeight="medium" whiteSpace="nowrap">
      Join {CUSTOMER_COUNT} seeing real results
    </Text>
  </HStack>
);
